import React, { useState, useEffect } from 'react';

const Configuration = ({ onConfigSave, forceEdit = false, onCancel }) => {
  const [webhookUrl, setWebhookUrl] = useState('');
  const [isConfigured, setIsConfigured] = useState(false);

  useEffect(() => {
    // Check if configuration exists in localStorage
    const savedWebhookUrl = localStorage.getItem('n8n_webhook_url');
    if (savedWebhookUrl) {
      setWebhookUrl(savedWebhookUrl);
      if (!forceEdit) {
        setIsConfigured(true);
      }
      // Don't call onConfigSave here - only call it when user actually saves
    }
  }, [forceEdit]);

  const handleSave = () => {
    if (webhookUrl.trim()) {
      localStorage.setItem('n8n_webhook_url', webhookUrl.trim());
      setIsConfigured(true);
      onConfigSave(webhookUrl.trim());
    }
  };

  const handleEdit = () => {
    setIsConfigured(false);
  };

  const handleClear = () => {
    localStorage.removeItem('n8n_webhook_url');
    setWebhookUrl('');
    setIsConfigured(false);
    onConfigSave('');
  };

  // Show edit form if forceEdit is true, regardless of isConfigured state
  if (isConfigured && !forceEdit) {
    return (
      <div className="config-panel configured">
        <div className="config-status">
          <h3>✓ Configuration Complete</h3>
          <p>N8N Webhook connected and ready</p>
          <div className="config-actions">
            <button className="btn btn-secondary" onClick={handleEdit}>
              Edit Configuration
            </button>
            <button className="btn btn-secondary" onClick={handleClear}>
              Clear Configuration
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="config-panel">
      <h2>⚙️ {webhookUrl ? 'Edit Configuration' : 'Setup Required'}</h2>
      <p>{webhookUrl ? 'Update your N8N webhook URL below:' : 'Configure your N8N webhook URL to connect the frontend to your workflow.'}</p>
      
      <div className="config-form">
        <div className="form-group">
          <label htmlFor="webhook-url">
            N8N Webhook URL:
          </label>
          <input
            type="url"
            id="webhook-url"
            className="config-input"
            value={webhookUrl}
            onChange={(e) => setWebhookUrl(e.target.value)}
            placeholder="https://your-n8n-instance.com/webhook/your-webhook-id"
          />
          <small className="help-text">
            Find this URL in your N8N workflow's "When chat message received" trigger node.
          </small>
        </div>
        
        <div className="config-instructions">
          <h4>How to find your webhook URL:</h4>
          <ol>
            <li>Open your N8N workflow</li>
            <li>Click on the "When chat message received" node</li>
            <li>Copy the webhook URL shown in the node</li>
            <li>Paste it above and click "Save Configuration"</li>
          </ol>
        </div>

        <div className="button-group">
          <button 
            className="btn btn-primary"
            onClick={handleSave}
            disabled={!webhookUrl.trim()}
          >
            Save Configuration
          </button>
          {forceEdit && (
            <button 
              className="btn btn-secondary"
              onClick={() => {
                if (onCancel) {
                  onCancel();
                } else {
                  const savedUrl = localStorage.getItem('n8n_webhook_url');
                  if (savedUrl) {
                    setWebhookUrl(savedUrl);
                    setIsConfigured(true);
                  }
                }
              }}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Configuration;